console.log("%c Design & Developed by Sixtudio.", "background: black; padding:5px; font-size: 10px; color: #ffffff");
console.log("%c > Site: https://sixtudio.com", "background: black; padding:5px; font-size: 10px; color: #ffffff");
console.log("");

document.addEventListener("DOMContentLoaded", function() {
  const productExtraInformation = document.querySelector("#product-extra-information");

  if (productExtraInformation) {
    const accordions = productExtraInformation.querySelectorAll(".accordion");

    accordions.forEach((accordion) => {
      const accordionContent = accordion.querySelector(".accordion__content");

      if (accordionContent && accordionContent.textContent.trim() === "####") {
        accordion.remove();
      }
    });
  }
});

document.addEventListener("DOMContentLoaded", function() {
  const imageBlock = document.querySelector(".footer__block.footer__block--image");
  if (imageBlock) {
    const image = imageBlock.querySelector("img");
    const textBlock = document.querySelector(".footer__block.footer__block--text");

    if (textBlock) {
      const vStack = textBlock.querySelector(".v-stack");
      if (vStack && image) {
        vStack.appendChild(image.cloneNode());
      }
    }

    imageBlock.parentNode.removeChild(imageBlock);
  }
});

function doCreatePrivacyCheckbox(id, name) {
  const config = window.doTheme || {};
  const privacyPolicyUrl = config.privacyPolicyUrl || "/policies/privacy-policy";
  const privacyPolicyText = config.privacyPolicyText || "He leído y acepto la";
  const privacyPolicyLinkText = config.privacyPolicyLinkText || "política de privacidad";
  const wrapper = document.createElement("div");
  const link = document.createElement("a");
  const label = document.createElement("label");
  const input = document.createElement("input");

  wrapper.className = "checkbox-control do-privacy-checkbox";
  input.id = id;
  input.className = "checkbox";
  input.type = "checkbox";
  input.name = name;
  input.required = true;
  link.href = privacyPolicyUrl;
  link.className = "link";
  link.target = "_blank";
  link.rel = "noopener";
  link.textContent = privacyPolicyLinkText;
  label.htmlFor = id;
  label.append(privacyPolicyText + " ", link);
  wrapper.append(input, label);

  return wrapper;
}

document.addEventListener("DOMContentLoaded", function() {
  const registerForm = document.querySelector("form#create_customer");
  const passwordInput = registerForm?.querySelector('input[name="customer[password]"]');
  if (!passwordInput || registerForm.querySelector('input[name="customer[accepts_privacy_policy]"]')) {
    return;
  }

  const passwordControl = passwordInput.closest(".form-control");
  const wrapper = doCreatePrivacyCheckbox("do-accepts-privacy-policy", "customer[accepts_privacy_policy]");

  if (passwordControl) {
    passwordControl.insertAdjacentElement("afterend", wrapper);
  }
});

function doInjectCartPrivacyCheckboxes() {
  document.querySelectorAll("form.cart-page, form.cart-drawer__footer").forEach((form, index) => {
    if (form.querySelector('input[name="attributes[accepts_privacy_policy]"]')) {
      return;
    }

    const target = form.querySelector(".button-group") || form.querySelector('button[name="checkout"]');
    const wrapper = doCreatePrivacyCheckbox(`do-cart-accepts-privacy-policy-${index}`, "attributes[accepts_privacy_policy]");
    wrapper.classList.add("do-cart-privacy");

    if (target) {
      target.insertAdjacentElement("beforebegin", wrapper);
    }
  });
}

document.addEventListener("DOMContentLoaded", function() {
  doInjectCartPrivacyCheckboxes();

  const cartDrawer = document.querySelector("cart-drawer");
  if (cartDrawer) {
    new MutationObserver(doInjectCartPrivacyCheckboxes).observe(cartDrawer, { childList: true, subtree: true });
  }
});

function doOpenCookiePreferences() {
  const fallback = () => document.querySelector("privacy-banner")?.show?.();

  if (window.privacyBanner?.showPreferences) {
    const result = window.privacyBanner.showPreferences();
    result?.catch?.(fallback);
    return;
  }

  fallback();
}

document.addEventListener("click", function(event) {
  const trigger = event.target.closest?.('a[href="#cookies"]');

  if (!trigger) {
    return;
  }

  event.preventDefault();
  doOpenCookiePreferences();
});

document.addEventListener("DOMContentLoaded", function() {
  if (window.location.hash === "#cookies") {
    doOpenCookiePreferences();
  }
});
